import { handleActions } from 'redux-actions'
import * as type from './type'


export const initialState = {
    confirmationModalOpen: false,
    invoice: null,
    invoiceCorrection: null,
    fetching: false,
    error: null,
    invoiceCorrectionData: {
        customText: '',
    },
}


export default handleActions({
    [type.FIND_INVOICE_BY_ID_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_INVOICE_BY_ID_SUCCESS]: (state, action) => {
        const { invoice } = action.payload
        return {
            ...state,
            fetching: false,
            invoice: {
                ...invoice,
                invoiceItemList: invoice.invoiceItemList.map(invoiceItem => ({
                    ...invoiceItem,
                    correctionAmount: 0,
                })),
            },
        }
    },
    [type.FIND_INVOICE_BY_ID_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.SHOW_CONFIRMATION_MODAL]: (state, action) => {
        return {
            ...state,
            confirmationModalOpen: true,
        }
    },
    [type.CLOSE_CONFIRMATION_MODAL]: (state, action) => {
        return {
            ...state,
            confirmationModalOpen: false,
        }
    },
    [type.CHANGE_INVOICE_CORRECTION_ITEM]: (state, action) => {
        const { invoiceItemId, name, value } = action.payload
        return {
            ...state,
            invoice: {
                ...state.invoice,
                invoiceItemList: state.invoice.invoiceItemList.map(invoice => {
                    return invoice.id !== invoiceItemId ? invoice : {
                        ...invoice,
                        [name]: value,
                    }
                }),
            },
        }
    },
    [type.CHANGE_INVOICE_CORRECTION_DATA]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            invoiceCorrectionData: {
                ...state.invoiceCorrectionData,
                [name]: value,
            },
        }
    },
    [type.CREATE_INVOICE_CORRECTION_REQUEST]: (state, action) => {
        return {
            ...state,
            confirmationModalOpen: false,
            fetching: true,
        }
    },
    [type.CREATE_INVOICE_CORRECTION_SUCCESS]: (state, action) => {
        const { invoiceCorrection } = action.payload
        return {
            ...state,
            invoiceCorrection,
            fetching: false,
        }
    },
    [type.CREATE_INVOICE_CORRECTION_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/invoice/state/correction/reducer.js